import React, { FC, useCallback, useState } from 'react';
import { AddResponsiblePersonForm } from '../../components/AddResponsiblePersonForm';
import styles from './AdminResponsiblePerson.module.css';
import { Paper, Stack } from '@mui/material';
import { useUserService } from '../../services/user.service';
import { TextToCopy } from '../../components/TextToCopy';
import { useTranslation } from '../../services';

interface AdminResponsiblePersonInterface {}

const AdminResponsiblePerson: FC<AdminResponsiblePersonInterface> = () => {
	const { t } = useTranslation();
	const { acceptBasicFlow } = useUserService();
	const [infoUser, setInfoUser] = useState<
		{ email: string; password: string } | undefined
	>();
	const registerResponsiblePerson = useCallback(
		async (props: { email: string }) => {
			const res = await acceptBasicFlow(props);
			if (res?.email) {
				setInfoUser(res);
			} else {
				setInfoUser(undefined);
			}
		},
		[acceptBasicFlow]
	);
	return (
		<>
			<Paper elevation={2} className={styles.background}>
				<AddResponsiblePersonForm onSubmit={registerResponsiblePerson} />
				{infoUser && (
					<Stack sx={{ p: '10px' }}>
						<TextToCopy
							text={infoUser.email}
							title={t('Copy')}
							label="Email"
						/>
						<TextToCopy
							text={infoUser.password}
							title={t('Copy')}
							label="Password"
						/>
					</Stack>
				)}
			</Paper>
		</>
	);
};

export default AdminResponsiblePerson;
